import { navSectionKeys } from "NavBar/navBarStore";

import { marketingColors, navAccentColors } from "UI/colors";

import { addOpacity } from "Utilities/Colors/colorUtils";

const inactiveBackgroundColor = addOpacity(marketingColors.darkBlue, 0.6);
const activeBackgroundColor = navAccentColors[navSectionKeys.groups][1];

export { inactiveBackgroundColor, activeBackgroundColor };
